module.exports = __webpack_public_path__ + "img/deco-28.2996ad33.png";